import { format, isValid, parseISO } from 'date-fns';

export const prepareDateFnsFormat = (formatStr: string): string => {
  return formatStr.replace(/DD/g, 'dd').replace(/YYYY/g, 'yyyy');
};

/**
 * Format the given ISO date to a specified format.
 *
 * @param {string} date - The input ISO date string in local time zone (e.g., '2024-08-20T09:56:59.287').
 * @param {string} formatStr - The desired output date format (e.g., 'MM/dd/yyyy h:mm:ss a').
 * @returns {string} - The formatted date as a string.
 */
export const formatDate = (date: string, formatStr: string): string => {
  if (!date) {
    return '';
  }

  if (!formatStr) {
    return date;
  }

  const parsedDate = parseISO(date);
  if (!isValid(parsedDate)) {
    return '';
  }

  const outputFormat = prepareDateFnsFormat(formatStr);

  return format(parsedDate, outputFormat);
};
